<template>
  <UiBox class="ui-box-apply" bgType="light" layout="single">
    <template v-slot:nav-left>
      <UiTab class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">信息确认</span>
          <span class="label-text">信息确认</span>
        </div>
      </UiTab>
    </template>
    <template v-slot:nav-right>
      <div class="right-box">
        <button class="btn-exit" @click="handleExit"></button>
      </div>
    </template>
    <template v-slot:container>
      <div class="inner-container">
        <div class="scroll-box">
          <div class="info-box">
            <div class="row" v-for="item in question" :key="item.id">
              <div class="q">{{ item.q }}</div>
              <div class="checkbox">
                <div class="yes" :class="{ active: item.state === '1' }">
                  <div class="label-box">
                    <span class="label-shadow">是</span>
                    <span class="label-text">是</span>
                  </div>
                  <input type="radio" :name="item.id" v-model="item.state" value="1">
                </div>
                <div class="no" :class="{ active: item.state === '2' }">
                  <div class="label-box">
                    <span class="label-shadow">否</span>
                    <span class="label-text">否</span>
                  </div>
                  <input type="radio" :name="item.id" v-model="item.state" value="2">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="bg"></div>
          <UiButton class="btn prev" colorType="red" @click="prev">
            <div class="label-box">
              <span class="label-shadow">上一项</span>
              <span class="label-text">上一项</span>
            </div>
          </UiButton>
          <UiButton class="btn next" colorType="gold" @click="next">
            <div class="label-box">
              <span class="label-shadow">下一项</span>
              <span class="label-text">下一项</span>
            </div>
          </UiButton>
        </div>
      </div>
    </template>
  </UiBox>
</template>

<script setup>
import { computed, inject } from 'vue'
import { useConfig } from '@/composables/useConfig'
import { usePrompt } from '@/composables/usePrompt'
import UiBox from '@/components/ui-box';
import UiTab from '@/components/ui-tab';
import UiButton from '@/components/ui-button';

const handleStepSubmit = inject('handleStepSubmit')
const handleStep = inject('handleStep')
const { showPrompt: promptMsg } = usePrompt()
const mockApply = inject('mockApply', null)

const emit = defineEmits(['confirm'])

const config = useConfig()

const question = computed(() => {
  if(config.value.registration_questions) {
    return config.value.registration_questions.map(item => {
      if (typeof item.state !== 'string') {
        item.state = ''
      }
      return item;
    })
  }else {
    return [];
  }
})

function prev() {
  handleStep(2)
}

function validInfo() {
  let valid = true;
  for(let item of question.value) {
    if(typeof item.state === 'string' && item.state === '') {
      valid = false;
      promptMsg('请进行信息确认')
      break;
    }
  }

  return valid;
}

function next() {
  if (mockApply?.bypassValidate) {
    handleStepSubmit(3, question.value);
    handleStep(4)
    return
  }
  let valid = validInfo()
  if(valid) {
    handleStepSubmit(3, question.value);
    handleStep(4)
  }
}

function handleExit() {
  emit('confirm')
}
</script>

<style lang="scss" scoped>
@import './_form';

// step3 独有
.title i {
  @include icon_status('info_2');
}

.inner-container {
  .scroll-box {
    .info-box {
      width: get_vw(820);
      margin: get_vh(27) auto;
      @include r(font-size, 20);
      color: #333;
      // overflow: hidden;
      .row {
        width: 100%;
        height: get_vh(54);
        display: flex;
        justify-content: space-between;
        align-content: center;
        margin-bottom: get_vh(19);
        .q {
          flex: 1;
          display: flex;
          align-items: center;
        }
        .checkbox {
          width: get_vh(160);
          height: 100%;
          display: flex;
          justify-content: flex-end;
          margin-left: get_vh(30);
          .yes, .no {
            position: relative;
            width: get_vh(54);
            height: get_vh(54);
            display: flex;
            justify-content: center;
            align-items: center;
            background: url(https://website.xdcdn.net/poster/58881/26match/common/P9japrva.png) center/contain no-repeat;
            // overflow: hidden;
            @include boxShadowSet_Btn;
            margin-left: get_vh(15);
            .label-box {
              .label-shadow {
                color: #FFFFFF;
              }
              .label-text {
                color: #616161;
              }
            }
            input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              margin: 0;
              opacity: 0;
            }

            &.active {
              background-image: url(https://website.xdcdn.net/poster/58881/26match/common/P9jap483.png);
              .label-box {
                .label-shadow {
                  color: #760000;
                }
                .label-text {
                  color: #FFFFFF;
                }
              }
            }
          }
        }
      }
    }
  }
  .bottom-box {
    justify-content: space-between;
    .btn {
      &.prev {
        margin-left: get_vh(42);
      }
      &.next {
        margin-right: get_vh(42);
      }
    }
  }
}
</style>
